export default __webpack_public_path__ + "static/media/check-dark.ddcbb97f.svg";